import { Fragment } from 'preact'

export const RetourInfoContact = ({ content }) => {
  return (
    <Fragment>
      <h2 className="mt-2 mb-1">Retour d'information et contact</h2>
      {content ? (
        <div dangerouslySetInnerHTML={{ __html: content }}></div>
      ) : (
        <div>
          <p>
            Si vous n'arrivez pas à accéder à un contenu ou à un service, vous pouvez contacter le responsable du site pour être
            orienté vers une alternative accessible ou obtenir le contenu sous une autre forme.
            <ul class="list">
                <li>Envoyer un message à <a href="mailto:accessibilite.france@orange.com">accessibilite.france@orange.com</a></li>
            </ul>
          </p>
        </div>
      )}
    </Fragment>
  )
}
